import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { App } from './App.tsx'
import { AccountPage } from './routes/AccountPage.tsx'
import { AdminPage } from './routes/AdminPage.tsx'
import { LivePage } from './routes/LivePage.tsx'
import { LoginPage } from './routes/LoginPage.tsx'
import { SimuleringPage } from './routes/SimuleringPage.tsx'
import './styles/global.css'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <LivePage /> },
      { path: 'simulering', element: <SimuleringPage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: 'konto', element: <AccountPage /> },
      { path: 'login', element: <LoginPage /> },
    ],
  },
])

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root saknas')

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
